/**
 * LLM Cost Service
 * Admin API calls for LLM cost tracking
 */

import api from './api';

const llmCostService = {
  /**
   * Get platform-wide LLM costs
   * @param {string} period - 'daily' or 'monthly'
   * @param {string} start - Start date/month
   * @param {string} end - End date/month
   * @returns {Promise<Object>} Platform cost summary
   */
  getPlatformCosts: async (period = 'monthly', start, end) => {
    const params = { period };
    if (start) params.start = start;
    if (end) params.end = end;
    const response = await api.get('/v1/admin/llm-costs', { params });
    return response.data;
  },

  /**
   * Get tenant LLM cost breakdown
   * @param {string} tenantId - Tenant ID
   * @param {string} period - 'daily' or 'monthly'
   * @param {string} start - Start date/month
   * @param {string} end - End date/month
   * @param {string} model - Optional model filter
   * @returns {Promise<Object>} Tenant cost breakdown
   */
  getTenantCosts: async (tenantId, period = 'monthly', start, end, model) => {
    const params = { period };
    if (start) params.start = start;
    if (end) params.end = end;
    if (model) params.model = model;
    const response = await api.get(`/v1/admin/llm-costs/${tenantId}`, { params });
    return response.data;
  },

  /**
   * Get tenant LLM audit trail
   * @param {string} tenantId - Tenant ID
   * @param {string} start - Start date
   * @param {string} end - End date
   * @param {number} limit - Page size
   * @param {number} offset - Offset
   * @returns {Promise<Object>} Paginated audit trail
   */
  getAuditTrail: async (tenantId, start, end, limit = 100, offset = 0) => {
    const params = { limit, offset };
    if (start) params.start = start;
    if (end) params.end = end;
    const response = await api.get(`/v1/admin/llm-costs/${tenantId}/audit`, { params });
    return response.data;
  },
};

export default llmCostService;
